// https://pqina.nl/doka/docs/v7/api/instance/events
import React, { useState } from 'react'

import { DokaImageEditorModal } from 'react-doka'
import {
  setPlugins,
  plugin_crop,
  // plugin_resize,
  // plugin_filter,
  // plugin_finetune,
  plugin_crop_locale_en_gb,
  locale_en_gb,
  createDefaultImageReader,
  createDefaultImageWriter,
  colorStringToColorArray,
} from 'doka'
import isBrowser from 'utility/isBrowser'

// Register the required plugins
setPlugins(plugin_crop)

const InternalDokaImageEditor = ({
  src = '',
  aspectRatio = 1,
  onClose = () => console.log('Close Editor'),
  onFinish = (urlImage) => console.log('URL Image: ', urlImage),
  imageBackgroundColor='#fff',
}) => {
  const [loading, setLoading] = useState(true)

  if (!isBrowser || !src) return null

  const locale = {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    // ...plugin_resize_locale_en_ggb,
    // ...plugin_filter_locale_en_gb,
    // ...plugin_finetune_locale_en_gb
  }

  return (
    <DokaImageEditorModal
      imageReader={createDefaultImageReader()}
      imageWriter={createDefaultImageWriter()}
      src={src}
      locale={locale}
      imageCropAspectRatio={aspectRatio}
      imageBackgroundColor={
        imageBackgroundColor && colorStringToColorArray(imageBackgroundColor)
      }
      imageCropLimitToImage={false}
      onLoadStart={(res) => setLoading(true)}
      onProcess={(finalProcess) => {
        console.log('Finished Processing Image ', finalProcess)
        let finalImageFileUrl = URL.createObjectURL(finalProcess.dest)
        onFinish({ ...finalProcess, finalImageFileUrl })
      }}
      onHide={(res) => onClose()}
      onClose={(res) => onClose()}
      onLoad={(res) => setLoading(false)}
    />
  )
}

export default InternalDokaImageEditor
